import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import axios from "axios";
import { rem, goLink } from "assets/js/common";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { Cookies } from "react-cookie";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { setBottomColor } from "assets/js/apphandle";

const cookies = new Cookies();

export default function Popup() {
  const history = useHistory();

  const { accessiblePages } = useSelector((state) => state.user);

  const no = cookies.get("no");
  const token = cookies.get("X-AUTH-TOKEN");

  const [eventDrawer, setEventDrawer] = useState(false);
  const [allowDrawer, setAllowDrawer] = useState(false);
  const [popupList, setPopupList] = useState([]);
  const [allowPopup, setAllowPopup] = useState({});
  const [alert, setAlert] = useState(false);
  const [userInfo, setUserInfo] = useState("");

  const handleEventDrawerOpen = () => {
    setEventDrawer(true);
  };
  const handleDrawerRowClose = () => {
    setEventDrawer(false);
  };

  const handleAllowDrawerOpen = () => {
    setAllowDrawer(true);
  };
  const handleDrawerClose = () => {
    setAllowDrawer(false);
  };

  const handleAlertOpen = () => {
    setAlert(true);
  };
  const handleAlertClose = () => {
    setAlert(false);
  };

  const fetchData = async () => {
    const ap = cookies.get("allowPopup");
    const ep = cookies.get("eventPopup");

    // console.log("ap1", ap, moment(ap), moment(ap).isValid());
    // console.log("ep1", ep, moment(ep), moment(ep).isValid());

    await axios
      .get("/api/pp/pop-up", { params: { schMbrNo: token ? no : "" } })
      .then((res) => {
        if (res.data.data.popUpList) {
          setPopupList(res.data.data.popUpList);
          if (
            res.data.data.popUpList.length > 0 &&
            (!ep || !moment(ep).isValid()) // eventPopup 쿠키가 YYYYMMDD 형태로 값이 들어가있어야 팝업 생략
          ) {
            handleEventDrawerOpen();
          }
        }
        if (res.data.data.popUpNotificationDissent) {
          setAllowPopup(res.data.data.popUpNotificationDissent);
          if (
            res.data.data.popUpNotificationDissent &&
            (!ap || !moment(ap).isValid()) // allowPopup 쿠키가 YYYYMMDD 형태로 값이 들어가있어야 팝업 생략
          ) {
            handleAllowDrawerOpen();
          }
        }
      })
      .catch((error) => {});
  };

  const allowConsent = async () => {
    await axios
      .post("/api/pp/pop-up/consent-to-receive")
      .then((res) => {
        handleDrawerClose();
        handleAlertOpen();
      })
      .catch((error) => {});
  };

  const loadUserInfo = async () => {
    await axios
      .get("api/mb/member/my-info")
      .then((res) => {
        setUserInfo(res.data.data.member);
      })
      .catch((error) => {});
  };

  const closePopupToday = () => {
    setCookie("eventPopup", 1);
    handleDrawerRowClose();
  };

  const closePopup = () => {
    setCookie("allowPopup", 7);
    handleDrawerClose();
  };

  const setCookie = (name, expiredays) => {
    var endDate = new Date();
    endDate.setDate(endDate.getDate() + expiredays);
    endDate.setHours("00");
    endDate.setMinutes("00");
    endDate.setSeconds("00");

    // console.log("endDate", endDate);
    cookies.set(name, moment(endDate).format("YYYYMMDD"), {
      path: "/",
      expires: endDate,
    });
  };

  useEffect(() => {
    // const authToken = cookies.get("X-AUTH-TOKEN");
    // if (authToken) loadUserInfo();
    // else setUserInfo("");
    fetchData();
  }, []);

  useEffect(() => {
    if (eventDrawer === true || allowDrawer === true) {
      setBottomColor("FFFFFF");
    } else {
      setBottomColor("F1270B");
    }
  }, [eventDrawer, allowDrawer]);

  const checkLink = (link) => {
    handleDrawerRowClose();

    if (link) {
      if (link.indexOf("/") == 0) {
        let find = accessiblePages.find((page) => link.indexOf(page) > -1);
        if (find) {
          history.push(link);
        } else {
          if (token) {
            history.push(link);
          } else {
            dispatch(loadAlert(true));
          }
        }
      } else {
        goLink(link);
      }
    }
  };

  return (
    <>
      {/* <Button
        size="small"
        color="primary"
        variant="outlined"
        onClick={handleEventDrawerOpen}
      >
        event popup
      </Button> */}
      {/* ST : Drawer-row */}
      <Drawer
        id="eventPopup"
        anchor="bottom"
        open={eventDrawer}
        onClose={handleDrawerRowClose}
        className="drawer-common-bottom size-small out-btn push-popup"
        style={{ minHeight: "auto" }}
      >
        <Swiper
          pagination={true}
          modules={[Pagination]}
          className="popup-swiper"
          pagination={{
            type: "fraction",
          }}
        >
          {popupList.map((item, i) => (
            <SwiperSlide key={i} style={{ minHeight: rem(310) }}>
              <Button
                onClick={() => {
                  checkLink(item.link);
                }}
                style={{ width: "100%" }}
              >
                <LazyCDNImage
                  cdnUrl={item.imgUrl}
                  style={{ minHeight: rem(310) }}
                />
              </Button>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="drawer-out-btn">
          <Button className="btn-days-hidden" onClick={closePopupToday}>
            오늘 하루 보지 않기
          </Button>
          <Button className="btn-out-closed" onClick={handleDrawerRowClose}>
            닫기
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}
      {/* <Button
        size="small"
        color="primary"
        variant="outlined"
        onClick={handleAllowDrawerOpen}
      >
        popUp
      </Button> */}
      {/* ST : Drawer-row */}
      <Drawer
        id="allowPopup"
        anchor="bottom"
        open={allowDrawer}
        onClose={handleDrawerClose}
        className="drawer-common-bottom size-small out-btn"
      >
        <div className="drawer-body">
          <div className="push-box align-c">
            <div className="illust">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/icon_bell.svg`}
              />
            </div>
            <p className="text" style={{ paddingTop: rem(10) }}>
              <strong>혜택 알림 메시지를 받으시겠어요?</strong>
            </p>
            <Box component="span" className="count" mt={3}>
              혜택 알림 수신에 동의하시면
              <br /> 영수증/포인트 적립 및 사용정보와
              <br />
              이벤트, 혜택 등의 다양한 혜택안내를
              <br /> 받으실 수 있습니다.
            </Box>
            <Button className="link" onClick={handleDrawerClose}>
              아니오, 괜찮습니다
            </Button>
          </div>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained" onClick={allowConsent}>
            네, 알겠습니다
          </Button>
        </div>
        <div className="drawer-out-btn">
          <Button className="btn-days-hidden" onClick={closePopup}>
            1주일간 보지 않기
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}

      <Dialog
        open={alert}
        onClose={handleAlertClose}
        className="alert-wrap"
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitle className="tit-center" id="alert-dialog-title">
          광고성 알림 수신 동의
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            메가마트 앱에서 보내는 광고 PUSH 알림 수신 여부가 ‘동의‘ 로
            변경되었습니다.
            <br />
            <br />
            {moment().format("YYYY년 MM월 DD일")}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="btn-center">
          {/* <Button onClick={handleAlertClose}>Disagree</Button> */}
          <Button
            onClick={handleAlertClose}
            autoFocus
            variant="contained"
            color="primary"
            size="small"
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
